export default "__VITE_ASSET__B7ZSd93m__"